import AbstractApiModel from '@/models/abstracts/AbstractApiModel';

/**
 * POST /time_sheets/absence {member, period} : absence d'un employé déclarée par le Dirigeant ou le manager de son
 * équipe (feuille créée, ou à la place de son brouillon, ses lignes supprimées). Répond la feuille (id). La signer
 * aussitôt : signTimeSheet ensuite, comme toute validation.
 */
export default class TimeSheetAbsenceModel extends AbstractApiModel {
  protected _path = '/time_sheets/absence';
}
